// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1bn5_","header":"MessagesList_header__3GgQI","chat":"MessagesList_chat__5xtHn"};